import { HTTPAUTH } from "../lib/httplib"

const state = {
  customer: {},
}

const mutations = {
  set_customer (state, customer) {
    state.customer = customer
  },
}

const actions = {
  create (context, customer) {
    return new Promise((resolve, reject) => {
      if (customer.type) {
        customer.type_id = customer.type.id
      }
      HTTPAUTH.post("/api/v1/customer", customer)
        .then((resp) => {
          resolve(resp.data.data)
        })
        .catch(eres => {
          reject(eres)
        });
    })
  },
}

const getters = {
}

export default {
  state, getters, mutations, actions
}